export default __webpack_public_path__ + "static/media/header.ecd8b27b.jpg";